import axios from 'axios';
import { toast } from 'react-toastify';

export const callUseMapApi = async (
    clientCode: string,
    setIsUserAuthorized: React.Dispatch<React.SetStateAction<boolean>>,
    setIsLoading: React.Dispatch<React.SetStateAction<boolean>>,
) => {
    try {
        const result = await axios.get(`${process.env.REACT_APP_API_URL}/Client/map/UseMap?clientCode=${clientCode}`);
        // console.log('result: ', result);
        if (result.data.messageCode === -12) {
            toast.error(result.data.message[0]);
        }
        setIsUserAuthorized(result.status === 200);
        setIsLoading(false);
    } catch (error: any) {
        // console.log('error: ', error);
        setIsUserAuthorized(false);
        setIsLoading(false);
    }
};
